import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import OrderWindow from './OrderWindow';
import { Date } from '../components';

const SidebarItem = ({ item, isSelected, onClick, showClosureNote }) => {
  const className = classnames('SidebarItem', isSelected && 'selected');

  return (
    <div className={className} onClick={() => onClick(item)}>
      <div className='SidebarItem__name headline-5'>{item.name}</div>
      <div className='SidebarItem__date headline-5'>
        <Date value={item.begin} /> -
        <Date value={item.end} />
      </div>
      {showClosureNote && <div className='SidebarItem__closureNote'>{item.closureNote}</div>}
    </div>
  );
};

SidebarItem.defaultProps = {
  isSelected: false,
  showClosureNote: false
};

SidebarItem.propTypes = {
  item: PropTypes.instanceOf(OrderWindow).isRequired,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  showClosureNote: PropTypes.bool
};

export default SidebarItem;
